import React, { useEffect, useRef } from 'react';
import ChatMessage from './ChatMessage';

const ConversationArea = ({ messages, isTyping = false }) => {
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, isTyping]);

  if (messages.length === 0 && !isTyping) {
    return (
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="text-center">
          <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
            <div className="w-8 h-8 bg-primary/20 rounded-full flex items-center justify-center">
              <div className="w-4 h-4 bg-primary/40 rounded-full"></div>
            </div>
          </div>
          <p className="text-text-secondary text-sm">
            Your conversation will appear here
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto p-4 space-y-4">
      <div className="max-w-2xl mx-auto">
        {messages.map((message, index) => (
          <ChatMessage
            key={index}
            message={message.content}
            isUser={message.isUser}
            timestamp={message.timestamp}
          />
        ))}
        
        {isTyping && (
          <ChatMessage
            isTyping={true}
          />
        )}
        
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
};

export default ConversationArea;